import React from "react";
import { Card, Spin } from "antd";

const LoadingSpinner = () => {
  return (
    <Card title="Mappa Clienti">
      <div
        style={{
          height: "calc(100vh - 130px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spin tip="Caricamento mappa..." />
      </div>
    </Card>
  );
};

export default LoadingSpinner; 